import { createContext } from "react";

export const CertificateContext = createContext({});
